import { jsx as r } from "react/jsx-runtime";
import { withDatasourceCheck as o } from "@sitecore-jss/sitecore-jss-nextjs";
const e = () => /* @__PURE__ */ r("p", { children: "SharedTabs" }), s = o()(e);
export {
  s as SharedTabs
};
